import {KpiVisibilityFlag} from '@hconnect/common/types'
import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {PlantStatusKpisContainer, RELIABILITY_ENGINEER_KPI_TYPES} from '@widgets/kpis'
import {Link} from 'react-router'

type Props = {
  plantId: string
  plantStatusPageHref?: string
}

export const ReliabilityPlantStatusKpisContainer: React.FC<Props> = ({
  plantId,
  plantStatusPageHref
}) => {
  const cardContent = (
    <PlantStatusKpisContainer
      plantId={plantId}
      kpiVisibilityFlag={KpiVisibilityFlag.ReliabilityEngineerEntryPoint}
      kpiTypes={RELIABILITY_ENGINEER_KPI_TYPES}
    />
  )

  if (!plantStatusPageHref) {
    return cardContent
  }

  return (
    <CardLinkWrapper<typeof Link>
      component={Link}
      to={plantStatusPageHref}
      data-test-id="plant-status-kpis-card-link-to-performance-plant-status"
    >
      <PlantStatusKpisContainer
        plantId={plantId}
        kpiVisibilityFlag={KpiVisibilityFlag.ReliabilityEngineerEntryPoint}
        kpiTypes={RELIABILITY_ENGINEER_KPI_TYPES}
      />
    </CardLinkWrapper>
  )
}
